import { get, post } from '../baseService'
import { CreateDatabaseModel } from 'app/models/createDatabaseModel'
import { DatabaseModel } from 'app/models/databaseModel'

const create = () => {
  const getDatabases = (companyId: string) =>
    get(
      companyId != null
        ? `/config-api/database?&companyId=${companyId}`
        : '/config-api/database',
    )
  const getPagedDatabases = (
    companyId?: string,
    take?: number,
    skip?: number,
    orderBy?: string,
    descending?: boolean,
    searchValue?: string,
    serverId?: number,
    databaseId?: number,
    migrationStalled?: boolean,
  ) => {
    const stalled = migrationStalled ? '&migrationStalled=true' : ''
    const url =
      companyId == null
        ? `/config-api/database?&paged=true&take=${take}&skip=${skip}&orderBy=${orderBy}&descending=${descending}&searchValue=${searchValue}&serverId=${serverId != null ? serverId : 0}&databaseId=${databaseId != null ? databaseId : 0}${stalled}`
        : `/config-api/database?&paged=true&companyId=${companyId}&take=${take}&skip=${skip}&orderBy=${orderBy}&descending=${descending}&searchValue=${searchValue}&serverId=${serverId != null ? serverId : 0}&databaseId=${databaseId != null ? databaseId : 0}${stalled}`
    return get(url)
  }
  const getDatabasesByServer = (companyId: string, serverId: string) => {
    const url =
      companyId != null
        ? `/config-api/database/list?&companyId=${companyId}&serverId=${serverId}`
        : `/config-api/database/list?&serverId=${serverId}`
    return get(url)
  }
  const getDatabase = (databaseId: string) =>
    get(`/config-api/database/${databaseId}`)
  const addDatabase = (database: CreateDatabaseModel) =>
    post('/config-api/database/create', database, false)
  const editDatabase = (database: DatabaseModel) =>
    post('/config-api/database/edit', database, false)
  const deleteDatabase = (ids: string[]): Promise<Array<any>> => {
    const createPromise = (id: string) => {
      return new Promise((resolve, reject) => {
        post('/config-api/database/delete', { id }, false)
          .then((value) => resolve({ id: id, success: true }))
          .catch((error) => reject({ id: id, success: false }))
      })
    }

    const promises = []
    for (const id of ids) {
      promises.push(
        createPromise(id).catch((error) => {
          return error
        }),
      )
    }

    return new Promise((resolve) => {
      Promise.all(promises).then((result) => {
        resolve(result)
      })
    })
  }

  const activateDatabase = (databaseIds: string[], isActive: boolean) =>
    post(
      '/config-api/database/activate',
      {
        databaseIds: databaseIds.map(id => parseInt(id)),
        isActive: isActive,
      },
      true,
    )

  const retryMigration = (databaseIds: string[]) =>
    post(
      '/config-api/database/retry-migration',
      { databaseIds: databaseIds.map((id) => parseInt(id)) },
      false,
    )

  return {
    retryMigration,
    getDatabases,
    getDatabasesByServer,
    getDatabase,
    addDatabase,
    editDatabase,
    deleteDatabase,
    getPagedDatabases,
    activateDatabase,
  }
}

export default {
  create,
}
